import { ConfiguredDataServicesSubscription } from "../../graphql/generated/operations";

/**
 * @param {ConfiguredDataServicesSubscription | undefined} data
 * @returns {ConfiguredDataServicesSubscription["configuredDataServices"] | undefined}
 */
export const formatter = (data) =>
  data?.configuredDataServices.filter(({ data_service }) => !!data_service);
